module.exports = require("plotly.js");